import appConfiguration from "@/components/cfg/AppCfg";
const { apiUrl, apiVersion } = appConfiguration;

const endpoints = {
  Account: "account",
  Agreements: "agreements",
  Questionnaire: "agreements/questionnaire",
  Clients: "clients",
  Contractors: "contractors",
  ContractorsStudents: "contractors/students",
  DefaultRates: "default-rates",
  Services: "services-and-goods",
  InvoicingCompanies: "invoicing-companies",
  InvoiceSpecifications: "invoice-specifications",
  Networks: "networks",
  Payrolls: "payrolls",
  PayrollTypes: "payroll-types",
  ProductGroup: "product-group-list",
  ProductList: "product-list",
  Products: "products",
  ProjectTypes: "project-types",
  Projects: "projects",
  ProjectSettlements: "project-settlements",
  ProjectPeriodConfirmations: "project-period-confirmations",
  Provinces: "provinces",
  ShiftReportDepartments: "shift-report-departments",
  ShiftReports: "shift-reports",
  Shifts: "shifts",
  StoreFormats: "store-formats",
  StoreGroups: "store-groups",
  StoreStatuses: "store-statuses",
  Stores: "stores",
  Surveys: "surveys",
  SurveysTemplates: "survey-templates",
  SystemRoles: "system-roles",
  TaxStatuses: "tax-statuses",
  UpdatesDepartments: "updates-departments",
  Users: "users",
  RoleBasedAssignments: "role-based-assignments",
  DepartmentBasedAssignments: "department-based-assignments",
  DepartmentBasedProject: "department-based-project",
  DepartmentBasedProjectRates: "department-based-project-rates",
  RoleBasedProject: "role-based-project",
  RoleBasedProjectRates: "role-based-project-rates",
  PayrollDepartments: "payroll-departments",
  TimesheetEntries: "timesheet-entries",
  ContractorVisits: "contractor-visits",
  StructureAssignments: "structure-assignments",
  StructureAssignmentTypes: "structure-assignments/types",
  AgreementCompanies: "agreement-companies",
  AgreementTypes: "agreement-types",
  TaxOffices: "tax-offices",
  Citizenships: "citizenships",
  DisabilityCertificates: "disability-certificates",
  DisabilityPensionTypes: "disability-pension-types",
  ContractorCards: "contractor-cards",
  HealthCheck: "health",
  DefaultStoreProjectAssignees: "default-store-project-assignees",
  StoreProjectAssignees: "store-project-assignees",
  ContractorPanelVisits: "contractor-panel/visits",
  ContractorPanelCards: "contractor-panel/cards",
  ContractorPanelPlannedHours: "contractor-panel/planned-hours",
  ContractorsPlannedHours: "contractors/planned-hours",
  ContractorsPlannedHoursApprovals: "contractors/planned-hours-approvals",
  ContractorsPlannedHoursWizard: "contractors/planned-hours/wizard",
  ContestAgreements: "contest-agreements",
  AuditLogs: "audits",
  Emails: "emails",
  AppSettings: "app-settings",
} as const;

export const API = Object.entries(endpoints).reduce(
  (acc, [key, value]) => {
    acc[key as keyof typeof endpoints] = `${apiUrl}/${apiVersion}/${value}`;
    return acc;
  },
  {} as Record<
    keyof typeof endpoints,
    `${string}/${string}/${(typeof endpoints)[keyof typeof endpoints]}`
  >,
);
export type APIValues = (typeof API)[keyof typeof API];
